"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketEntryHistory = void 0;
var TicketEntryHistoryList_1 = require("./TicketEntryHistoryList");
var TicketEntryHistory = /** @class */ (function () {
    function TicketEntryHistory(data) {
        this.enteredDateConverted = null;
        this.enteredTimeConverted = null;
        this.barcodeDisplayValue = null;
        this.isOnlineEntry = false;
        this.id = data.id;
        this.enteredTime = data.enteredTime;
        this.login = data.login;
        this.gameLogId = data.gameLogId;
        this.ticketId = data.ticketId;
        this.ticket = data.ticket;
        this.game = data.game;
        this.prizes = data.prizes;
    }
    TicketEntryHistory.JsonToTickets = function (data) {
        var ticketEntryHistoryList = new TicketEntryHistoryList_1.TicketEntryHistoryList();
        data.forEach(function (ticket) {
            if (!ticketEntryHistoryList.map(function (x) { return x.id; }).includes(ticket.id)) {
                ticketEntryHistoryList.push(TicketEntryHistory.JsonToTicket(ticket));
            }
        });
        return ticketEntryHistoryList.getEnteredTimeConverted();
    };
    TicketEntryHistory.JsonToTicket = function (data) { return new TicketEntryHistory(data); };
    return TicketEntryHistory;
}());
exports.TicketEntryHistory = TicketEntryHistory;
//# sourceMappingURL=TicketEntryHistory.js.map